export const ADD_ACCOUNT_HOLDER = "ADD_ACCOUNT_HOLDER"
export const ADD_ACCOUNT_HOLDER_SUCCESS = "ADD_ACCOUNT_HOLDER_SUCCESS"
export const ADD_ACCOUNT_HOLDER_FAIL = "ADD_ACCOUNT_HOLDER_FAIL"
export const CLEAR_ACCOUNT_HOLDER = "CLEAR_ACCOUNT_HOLDER"

//  export const DELETE_ACCOUNT_HOLDER = "DELETE_ACCOUNT_HOLDER"
//  export const DELETE_ACCOUNT_HOLDER_SUCCESS = "DELETE_ACCOUNT_HOLDER_SUCCESS"
// export const DELETE_ACCOUNT_HOLDER_FAIL = "DELETE_ACCOUNT_HOLDER_FAIL"
 
